import { useCallback, useEffect, useState } from "react";
import SuccessScreen from "./SuccessScreen";
import { subscribeSuccessScreen } from "./successScreenBus";

/** Renders the app-wide success screen (5s; click outside or Esc closes it early). */
export default function SuccessScreenHost() {
  const [item, setItem] = useState(null);
  const close = useCallback(() => setItem(null), []);

  useEffect(() => subscribeSuccessScreen(setItem), []);

  useEffect(() => {
    if (!item) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") close();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [item, close]);

  if (!item) return null;

  return (
    <div
      className="fixed inset-0 z-[260] flex items-center justify-center bg-slate-900/20 backdrop-blur-[2px] px-4"
      onClick={close}
    >
      <div className="w-full max-w-lg shadow-xl rounded-3xl" onClick={(e) => e.stopPropagation()}>
        <SuccessScreen
          key={item.id}
          variant="panel"
          title={item.title}
          message={item.message}
          redirecting={item.redirecting}
          onComplete={close}
        />
      </div>
    </div>
  );
}
